import React from 'react';
import styled from 'styled-components';
import Secondarybutton from './SecondaryButton';
import phone from '../img/phone.svg';
import ring1 from '../img/ring_orange.svg';
import message1 from '../img/message_pink.svg';
import message2 from '../img/message_blue.svg';
import { Fade } from 'react-reveal';

function HeaderContent() {
    return ( 
        <HeaderContentStyled >
            <Fade left cascade>
            <div className = "left-content" >
                <div className = "left-text-container" >
                    <h1> Smart banking for freelancers </h1> 
                    <p className = "white" > Lorem ipsum dolor sit amet consectetur adipisicing elit.Velit molestiae minus dicta ipsum atque est, eveniet nisi. 
                    </p> 
                    <Secondarybutton name = { 'Register Now' }/> 
                </div > 
            </div> 
            </Fade > 
            <Fade right>
            <div className = "right-content" >
                <img src = { phone } alt = "" className = "phone" />
                < img src = { ring1 } alt = "" className = "ring1" />
                < img src = { message1 } alt = "" className = "message1" />
                < img src = { message2 } alt = "" className = "message2" / >
            </div> 
        </Fade > 
    </HeaderContentStyled>
    )
}

const HeaderContentStyled = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 3rem;
    @media screen and (max-width: 879px){
        flex-direction: column;
    }
    .left-content{
        width: 50%;
        display: flex;
        align-items: center;
        padding-right: 3rem;
        @media screen and (max-width: 879px){
           width: 100%;
           padding: 0;
        }
    }
        .white{
            color:white;
        }
        h1{
            font-size: 4rem;
            font-weight: 600;
            @media screen and (max-width: 1172px){
                font-size: 3rem;
            }
            @media screen and (max-width: 566px){
                font-size: 2.4rem;
            }
        }

        .white{
            padding: 1.4rem 0;
            line-height: 1.8rem;
        }
    }

    .right-content{
        width: 50%;
        position: relative;
        display: flex;
        justify-content: center;
        @media screen and (max-width: 879px){
           width: 100%
    }
        .phone{
            width: 80%;
        }
        .ring1{
            position: absolute;
            bottom: 10%;
            right: 0;
            left: auto;
            animation: move2 20s infinite;
            transition: all .4s ease-in-out;
            @media screen and (max-width: 786px){
                transform: scale(0.5) !important;
                width: 100px;
                height: 100px;
            }
        }
        .message1{
            position: absolute;
            top: 0;
            right: 0;
            left: auto;
            animation: move 5s infinite;
            transition: all .4s ease-in-out;
            @media screen and (max-width: 786px){
               display: none;
            }
        }
        .message2{
            position: absolute;
            bottom: 15%;
            left: 0;
            transition: all .4s ease-in-out;
            animation: move 8s infinite;
            animation-delay: .5s;
            transition: all .4s ease-in-out;
            @media screen and (max-width: 786px){
                transform: scale(0.5) !important;
                width: 100px;
                height: 100px;
            }
        }
    }

    //Header Animations
    .message1{
        @keyframes move{
            0%{
                transform: translateY(0) rotate(0) scale(1) translateX(0);
            }
            50%{
                transform: translateY(-10px) rotate(20deg) scale(1.1) translateX(10px);
            }
            100%{
                transform: translateY(0)  rotate(0deg) scale(1) translateX(0);
            }
        }
        @keyframes move2{
            0%{
                transform: translateY(0) rotate(0) scale(1) translateX(0);
            }
            50%{
                transform: translateY(-10px) rotate(60deg) scale(1.1) translateX(10px);
            }
            100%{
                transform: translateY(0)  rotate(0deg) scale(1) translateX(0);
            }
        }
    }
`;

export default HeaderContent